import { PaletteOptions } from "@mui/material";
import {
  BLACK,
  CUSTOM_WHITE,
  GREY_50,
  GREY_600,
  KEYBOARD_FOCUS_OUTLINE,
  WHITE,
  grey,
} from "../../colors";

type ProviderSearchNeutralColors = {
  base_dark: string;
  base_light: string;
  custom_blue: string;
  custom_light_blue: string;
  custom_white: string;
  dark_grey: string;
  light_grey: string;
  medium_grey: string;
};

declare module "@mui/material/styles" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Palette {
    neutrals: ProviderSearchNeutralColors;
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface PaletteOptions {
    neutrals?: ProviderSearchNeutralColors;
  }
}

// NEUTRALS
export const PROVIDER_SEARCH_LIGHT_GREY = GREY_50;
export const PROVIDER_SEARCH_MEDIUM_GREY = "#D8D8D8";
export const PROVIDER_SEARCH_DARK_GREY = GREY_600;
export const PROVIDER_SEARCH_CUSTOM_WHITE = CUSTOM_WHITE;
export const PROVIDER_SEARCH_BASE_LIGHT = "#E6E6D5";
export const PROVIDER_SEARCH_BASE_DARK = "#102832";
export const PROVIDER_SEARCH_CUSTOM_BLUE = "#2E4E8E";
export const PROVIDER_SEARCH_CUSTOM_LIGHT_BLUE = "#EBF1FB";

// COMMON
export const PROVIDER_SEARCH_WHITE = WHITE;
export const PROVIDER_SEARCH_BLACK = BLACK;

// SECONDARY
export const PROVIDER_SEARCH_SECONDARY_DARK = "#CFC0BD";
export const PROVIDER_SEARCH_SECONDARY_LIGHT = "#F1DAC4";

// SUCCESS
export const PROVIDER_SEARCH_SUCCESS_DARK = "#006144";
export const PROVIDER_SEARCH_SUCCESS_MAIN = "#00845C";
export const PROVIDER_SEARCH_SUCCESS_LIGHT = "#E0F9E7";

// ERROR
export const PROVIDER_SEARCH_ERROR_DARK = "#A1160A";
export const PROVIDER_SEARCH_ERROR_MAIN = "#D92E22";
export const PROVIDER_SEARCH_ERROR_LIGHT = "#FAECEC";

// WARNING
export const PROVIDER_SEARCH_WARNING_DARK = "#8F3415";
export const PROVIDER_SEARCH_WARNING_MAIN = "#FFA656";
export const PROVIDER_SEARCH_WARNING_LIGHT = "#FFF5E7";

export const paletteProviderSearchCore: PaletteOptions = {
  common: {
    black: PROVIDER_SEARCH_BLACK,
    white: PROVIDER_SEARCH_WHITE,
  },
  error: {
    dark: PROVIDER_SEARCH_ERROR_DARK,
    light: PROVIDER_SEARCH_ERROR_LIGHT,
    main: PROVIDER_SEARCH_ERROR_MAIN,
  },
  grey,
  mode: "light",
  neutrals: {
    base_dark: PROVIDER_SEARCH_BASE_DARK,
    base_light: PROVIDER_SEARCH_BASE_LIGHT,
    custom_blue: PROVIDER_SEARCH_CUSTOM_BLUE,
    custom_light_blue: PROVIDER_SEARCH_CUSTOM_LIGHT_BLUE,
    custom_white: PROVIDER_SEARCH_CUSTOM_WHITE,
    dark_grey: PROVIDER_SEARCH_DARK_GREY,
    light_grey: PROVIDER_SEARCH_LIGHT_GREY,
    medium_grey: PROVIDER_SEARCH_MEDIUM_GREY,
  },
  outline: {
    main: KEYBOARD_FOCUS_OUTLINE,
  },
  secondary: {
    dark: PROVIDER_SEARCH_SECONDARY_DARK,
    light: PROVIDER_SEARCH_SECONDARY_LIGHT,
    main: PROVIDER_SEARCH_SECONDARY_DARK,
  },
  success: {
    dark: PROVIDER_SEARCH_SUCCESS_DARK,
    light: PROVIDER_SEARCH_SUCCESS_LIGHT,
    main: PROVIDER_SEARCH_SUCCESS_MAIN,
  },
  warning: {
    dark: PROVIDER_SEARCH_WARNING_DARK,
    light: PROVIDER_SEARCH_WARNING_LIGHT,
    main: PROVIDER_SEARCH_WARNING_MAIN,
  },
} as const;
